import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RecentlyViewedService } from '@df/catalog-ui/recently-viewed/recently-viewed.service';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { Meta } from '@df/core/meta/meta';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { RelatedProductsComponent } from '../../../catalog/ui/related-products/related-products.component';
import { CMS_COMPONENT_RECENTLY_VISITED_PRODUCTS_CONFIG } from './recently-visited-products-carousel.config';
import { NCmsRecentlyVisitedProductsCarousel } from './recently-visited-products-carousel.interface';

@ICmsComponent<RecentlyVisitedProductsCarouselComponent>(CMS_COMPONENT_RECENTLY_VISITED_PRODUCTS_CONFIG)
@Component({
    selector: 'recently-visited-products-carousel',
    templateUrl: './recently-visited-products-carousel.component.html',
    styleUrl: './recently-visited-products-carousel.component.scss',
    standalone: true,
    imports: [ICmsClientModule, RelatedProductsComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentlyVisitedProductsCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsRecentlyVisitedProductsCarousel.IComponentData;

    protected app = inject(App);
    private meta = inject(Meta);
    private recentService = inject(RecentlyViewedService);

    CarouselType = NCmsRecentlyVisitedProductsCarousel.CarouselType;
    carouselType?: NCmsRecentlyVisitedProductsCarousel.CarouselType;

    get currentProductId(): number | undefined {
        const currentModel = <Product<IProductDataV3>>this.meta.model;

        return currentModel?.parent?.id || currentModel?.id;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.update();
    }

    override detectChanges(changes?: NICmsContentComponent.IDetectionChanges): void {
        if (
            (changes?.['component'] as NICmsContentComponent.Mutation)?.changeEvent?.valuePath?.includes('category_id') ||
            (changes?.['component'] as NICmsContentComponent.Mutation)?.changeEvent?.valuePath?.includes('min_qty_for_recently_viewed')
        ) {
            this.update();
        } else {
            super.detectChanges();
        }
    }

    update(): void {
        if (this.recentService.collection?.length >= this.component.min_qty_for_recently_viewed) {
            this.carouselType = NCmsRecentlyVisitedProductsCarousel.CarouselType.recentlyViewed;
        } else {
            this.carouselType = NCmsRecentlyVisitedProductsCarousel.CarouselType.category;
        }
        this.detectChanges();
    }
}
